import React from "react";
import PropTypes from "prop-types";
import styles from "./Prize.css";

const Prize = ({ prize }) =>
  prize ? (
    <div
      className={styles.prize}
      style={{ backgroundImage: `url(${prize.href})` }}
    />
  ) : null;

Prize.propTypes = {
  prize: PropTypes.object
};

export default Prize;



// WEBPACK FOOTER //
// ./src/components/Prizes/Prize.js